<template>
    <div class="data" v-loading="load">
        <div class="title">
            <p>
                <span @click="$router.push('/home/activityGoods')">活动商品</span>><span @click="$router.push('/home/activityGoods?type=' + type)">{{
                    type == "activity_team" ? "拼团" : type == "activity_share" ? "订单返现" : "接龙购"
                }}</span
                >><span>效果数据</span>
            </p>
        </div>
        <div class="main">
            <div class="card">
                <el-card class="search">
                    <div class="sub-title">
                        <h4>活动概括</h4>
                    </div>
                    <div v-if="info">
                        <p class="date">数据更新时间：{{ update }}</p>
                        <div>
                            <div class="list" v-if="type == 'activity_team'">
                                <div class="item">
                                    <p>开团数</p>
                                    <span>{{ info.open_team_count || 0 }}</span>
                                </div>
                                <div class="item">
                                    <p>已成团数</p>
                                    <span>{{ info.success_team_count || 0 }}</span>
                                </div>
                                <div class="item">
                                    <p>付费用户数</p>
                                    <span>{{ info.pay_user_count || 0 }}</span>
                                </div>
                                <div class="item">
                                    <p>商品销量</p>
                                    <span>{{ info.product_count || 0 }}</span>
                                </div>

                                <div class="item">
                                    <p>支付订单数</p>
                                    <span>{{ info.pay_order_count || 0 }}</span>
                                </div>

                                <div class="item">
                                    <p>成交总额</p>
                                    <span>{{ info.turnoverAmounts || 0 }}</span>
                                </div>
                            </div>
                            <div class="list" v-else-if="type == 'activity_link'">
                                <div class="item">
                                    <p>付费用户数</p>
                                    <span>{{ info.pay_user_count || 0 }}</span>
                                </div>
                                <div class="item">
                                    <p>龙头用户数</p>
                                    <span>{{ info.joins_user_count || 0 }}</span>
                                </div>
                                <div class="item">
                                    <p>商品销量</p>
                                    <span>{{ info.product_count || 0 }}</span>
                                </div>

                                <div class="item">
                                    <p>支付订单数</p>
                                    <span>{{ info.pay_order_count || 0 }}</span>
                                </div>

                                <div class="item">
                                    <p>成交总额</p>
                                    <span>{{ info.turnoverAmounts || 0 }}</span>
                                </div>
                                <div class="item">
                                    <p>返现总额</p>
                                    <span>{{ info.bonusAmounts || 0 }}</span>
                                </div>
                            </div>
                            <div class="list" v-else>
                                <div class="item">
                                    <p>付费用户数</p>
                                    <span>{{ info.pay_user_count || 0 }}</span>
                                </div>
                                <div class="item">
                                    <p>商品销量</p>
                                    <span>{{ info.product_count || 0 }}</span>
                                </div>

                                <div class="item">
                                    <p>支付订单数</p>
                                    <span>{{ info.pay_order_count || 0 }}</span>
                                </div>

                                <div class="item">
                                    <p>成交总额</p>
                                    <span>{{ info.turnoverAmounts || 0 }}</span>
                                </div>
                                <div class="item">
                                    <p>返现总额</p>
                                    <span>{{ info.bonusAmounts || 0 }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-empty description="暂无数据" v-else></el-empty>
                </el-card>
            </div>
        </div>
        <div class="main">
            <div class="card m0">
                <el-card class="search">
                    <div class="sub-title">
                        <h4>每日活动数据</h4>
                        <div>
                            <span>活动时间：</span>
                            <el-date-picker
                                v-model="date"
                                style="width: 380px"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                @change="getList"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="table">
                        <el-table :data="tableData" style="width: 100%" border>
                            <el-table-column :key="Math.random()" align="center" prop="created_at" label="时间" width="200px"> </el-table-column>
                            <el-table-column :key="Math.random()" align="center" label="ID" prop="id"> </el-table-column>
                            <!-- <el-table-column align="center" v-if="type == 'activity_team'" prop="date" label="开团数"> </el-table-column>
                            <el-table-column align="center" v-if="type == 'activity_team'" prop="date" label="已成团数"> </el-table-column> -->
                            <el-table-column :key="Math.random()" v-if="type == 'activity_team'" align="center" prop="success_people" label="开团人数"> </el-table-column>
                            <el-table-column :key="Math.random()" align="center" prop="orderCount" label="付费用户数"> </el-table-column>
                            <el-table-column :key="Math.random()" align="center" prop="goodsNumberCount" label="商品销量"> </el-table-column>
                            <el-table-column :key="Math.random()" align="center" prop="orderCount" label="支付订单数"> </el-table-column>
                            <el-table-column :key="Math.random()" align="center" prop="paymentsAmountsCount" label="成交金额(元)"> </el-table-column>
                            <!-- <el-table-column align="center" v-if="type == 'activity_link'" prop="date" label="龙头用户数"> </el-table-column> -->
                            <el-table-column :key="Math.random()" align="center" v-if="type == 'activity_share'" prop="limit_order_num" label="是否限制返现次数">
                                <template slot-scope="{ row }">
                                    {{ Number(row.limit_order_num) || "不限制" }}
                                </template>
                            </el-table-column>
                            <el-table-column :key="Math.random()" v-if="type != 'activity_team'" align="center" prop="feeAmountsCount" label="返现金额(元)"> </el-table-column>
                        </el-table>
                        <div class="page">
                            <el-pagination
                                @size-change="sizeChange"
                                @current-change="handleSizeChange"
                                :current-page="page"
                                :page-sizes="[10, 20, 30, 40]"
                                :page-size="size"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                                background
                            >
                            </el-pagination>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            date: [],
            tableData: [],
            type: "activity_team",
            load: false,
            info: null,
            page: 1,
            size: 10,
            total: 0,
            update: "",
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    mounted() {
        if (this.$route.query.type) {
            this.type = this.$route.query.type;
        }
        this.getList();
    },
    methods: {
        ...mapActions({
            getActivitystatistics: "commodity/getActivitystatistics",
        }),
        handleSizeChange(val) {
            this.page = val;
            this.getList();
        },
        sizeChange(val) {
            this.size = val;
            this.getList();
        },
        getList() {
            this.load = true;
            try {
                let params = {
                    token: this.getToken,
                    activity_name: this.$route.query.type,
                    start_time: this.date ? this.date[0] : null,
                    end_time: this.date ? this.date[1] : null,
                    activity_id: this.$route.query.activity_id,
                    activity_product_id: this.$route.query.product_id,
                    page: this.page,
                    size: this.size,
                };
                this.getActivitystatistics(params).then((res) => {
                    console.log(res);
                    if (res.code == 1) {
                        this.update = res.data.countArr.activityInvalidTime || res.data.countArr.activityEndTime || "无";
                        this.info = res.data.countArr;
                        this.tableData = res.data.data.data;
                        this.total = res.data.data.count;
                    }
                });
            } catch (err) {
                console.log(err);
            } finally {
                this.load = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.data {
    .page {
        margin: 20px 0;
        float: right;
    }
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;
        font-size: 18px;
        justify-content: space-between;
        color: #333;
        p {
            color: #333;
            span {
                margin: 0 8px;
                cursor: pointer;
                &:hover {
                    color: #409eff;
                }
                &:first-child {
                    margin-left: 0;
                }
                &:last-child {
                    &:hover {
                        color: #333;
                    }
                }
            }
        }
    }
    .main {
        min-width: 1200px;
        width: 100%;
        display: flex;
        .card {
            flex: 1;
            margin-right: 10px;
            width: 800px;
        }
    }
    .el-card {
        margin: 24px 0px 10px 24px;
        border-radius: 0;
        &:nth-child(2) {
            margin: 10px 0px 24px 24px;
        }
    }
    .m0 {
        .el-card {
            min-height: 470px;
            margin: 10px 0px 24px 24px;
        }
    }
    .table {
        margin-top: 22px;
    }
    .search {
        .sub-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            h4 {
                position: relative;
                &::before {
                    position: absolute;
                    content: "";
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    height: 16px;
                    width: 3px;
                    background: #133aff;
                }
                padding-left: 14px;
                font-size: 18px;
                font-weight: 600;
            }
        }
        .date {
            font-size: 16px;
            color: #666;
            margin: 22px 0;
        }
        .list {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 0 -10px;
            .item {
                flex: 1;
                margin: 10px;
                padding: 20px;
                border: 1px solid #ccc;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: space-between;
                border-radius: 5px;
                p {
                    font-size: 18px;
                    margin-bottom: 20px;
                    font-weight: 600;
                }
                span {
                    font-size: 32px;
                    color: #133aff;
                    font-weight: 600;
                }
            }
        }
    }
    .el-empty {
        padding: 0;
    }
}
</style>